import { render, staticRenderFns } from "./MethodsPaymentQuickAdd.vue?vue&type=template&id=72bf269c&"
import script from "./MethodsPaymentQuickAdd.vue?vue&type=script&lang=js&"
export * from "./MethodsPaymentQuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports